/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable  no-useless-escape */

import React, { useEffect, useMemo, useRef, useState } from 'react';
import './CustomConditionComponent.css';
import { CheckBox, CustomInput, SelectDropDown, useAppDispatch, useAppSelector, useEffectOnce } from '../../../globalUtils/globalExports';
import { cloneDeep, isInteger } from 'lodash';
import CustomDropDown, { ISelectOption } from './CustomDropDown';
import { clearDerivedConditionFormRedux, fetchAdvanceRuleEngineArithmeticOperatorsReferenceData, fetchAdvanceRuleEngineConnectivesReferenceData, fetchAdvanceRuleEngineRelationalOperatorReferenceData, fetchDerivedCondition, getReferenceDataReducer } from '../../../rmsReduxStore/reduxExports';
import { fetchAdvanceRuleEngineTriggerParameterReferenceData } from '../../../rmsReduxStore/reduxExports';
import { checkValidDecimal, checkValidInteger } from './ExecutionPlan';
import { Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { useNavigate } from 'react-router-dom';
import CustomChartPopup from '../../softwareReleaseManagement/dashboard/CustomChartPopup';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ConnectorScope, ConnectorType, parseOptionValues } from './CustomTriggerConditionComponent';

export type LogicalOperators = 'AND' | 'OR';

export interface ICustomCondition {
    condName: string;
    condIdx: number;

    paramId: string | null;
    paramLabel: string | null;
    paramType: string | null;
    paramLevel: string | null;
    operator: string | null;
    parameter1Value: number | string | null;
    parameter2Value: number | string | null;
    isParamTypeEnum: boolean;
    paramEnumValue: string[];
    paramUnit: string | null;
    isParamTypeDate: boolean;
    isDerived: boolean;
    connectorType: ConnectorType | null;
    connectorScope: ConnectorScope | null;

    arithmeticParamId: string | null;
    arithmeticParamLabel: string | null;
    arithmeticParamType: string | null;
    arithmeticParamLevel: string | null;
    arithmeticOperator: string | null;
    arithmeticParamValue: number | null;
    arithmeticParamUnit: string | null;
    arithmeticParamConnectorType: ConnectorType | null;

    connective: LogicalOperators | null;

    errorMessage: string | null;
    errorMessageSecondary: string | null;
    errorMessageArithmeticParam: string | null;
}

interface ICustomConditionComponentProps {
    condition: ICustomCondition;
    handleConditionUpdate: (conditionLabel: string, condition: ICustomCondition) => void;
    position: number;
    enableDerivedCondition: boolean;
}


export type ParameterType = 'STATUS' | 'SETTING' | 'ALARMS' | 'SYSTEM_INFO' | 'SESSION' | 'DERIVED';

const CustomConditionComponent: React.FC<ICustomConditionComponentProps> = ({ condition, handleConditionUpdate,position,enableDerivedCondition }) => {

    const parameterTypeList = [
        {
            id: 'STATUS',
            name: 'Status Parameter',
            label: 'Status Parameter',
            icon: 'rms__advance__rule__engine__status__icon'
        },
        {
            id: 'SETTING',
            name: 'Setting Parameter',
            label: 'Setting Parameter',
            icon: 'rms__advance__rule__engine__setting__icon'
        },
        {
            id: 'ALARMS',
            name: 'Alarms',
            label: 'Alarms',
            icon: 'rms__advance__rule__engine__alarm__icon'
        },
        {
            id: 'SYSTEM_INFO',
            name: 'System Info Parameter',
            label: 'System Info Parameter',
            icon: 'rms__advance__rule__engine__system__info__icon'
        },
        {
            id: 'SESSION',
            name: 'Session Parameter',
            label: 'Session Parameter',
            icon: 'rms__advance__rule__engine__session__icon'
        }
    ]

    const derivedConditionType = {
        id: 'DERIVED',
        name: 'Derived Conditions',
        label: 'Derived Conditions',
        icon: 'rms__advance__rule__engine__status__icon'
    }

    if(enableDerivedCondition)parameterTypeList.push(derivedConditionType)

    const dispatch = useAppDispatch();
    const {advanceRuleEngineTriggerParameterReferenceData,advanceRuleEngineArithmeticOperatorReferenceData,advanceRuleEngineConnectivesReferenceData,advanceRuleEngineRelationalOperatorReferenceData} = useAppSelector(getReferenceDataReducer);
    const parameterTypeValue = parameterTypeList?.filter(item => item?.id === condition?.paramType);
    const arithmeticParamTypeValue = parameterTypeList?.filter(item => item?.id === condition?.arithmeticParamType);
    const [selectedParameterType, setSelectedParameterType] = useState<ISelectOption | null>(condition?.paramType ? parameterTypeValue?.[0] : parameterTypeList?.[0]);
    const [arithmeticParamType, setArithmeticParamType] = useState<ISelectOption | null>(condition?.arithmeticParamType ? arithmeticParamTypeValue?.[0] : parameterTypeList?.[0]);
    const [enableArithmeticLogic, setEnableArtihmeticLogic] = useState<boolean>(condition?.arithmeticParamId ? true : false);
    const [selectedParameter, setSelectedParameter] = useState<IAdvanceRuleEngineTriggerParameterReferenceData | null>(null);
    const [selectedArithmeticParameter, setSelectedArtihmeticParameter] = useState<IAdvanceRuleEngineTriggerParameterReferenceData | null>(null);
    const parameterRef = useRef<IAdvanceRuleEngineTriggerParameterReferenceData[] | null>(null);
    parameterRef.current = advanceRuleEngineTriggerParameterReferenceData;
    const derivedConditionImageUrlRef = useRef<string | undefined>(undefined);
    const [showImage,setShowImage] = useState<boolean>(false);

    const connectorScopReferenceData = [
        {id: 'all', label: 'All', value: 'all', name: 'All'},
        {id: 'any', label: 'Any', value: 'any', name: 'Any'}
    ]


    useEffectOnce(() => {
        dispatch(fetchAdvanceRuleEngineTriggerParameterReferenceData());
        dispatch(fetchAdvanceRuleEngineArithmeticOperatorsReferenceData());
        dispatch(fetchAdvanceRuleEngineRelationalOperatorReferenceData());
        dispatch(fetchAdvanceRuleEngineConnectivesReferenceData());
    })

    useEffect(()=>{
        if(advanceRuleEngineArithmeticOperatorReferenceData) {
            parameterRef.current = advanceRuleEngineTriggerParameterReferenceData;
            
            const paramValue = parameterRef?.current?.filter(item => item?.parameterKey === condition?.paramId && (item?.acOrDcParam ?? '')?.toLowerCase() === (condition?.connectorType ?? '')?.toLowerCase());
            if(paramValue?.[0]) setSelectedParameter(paramValue?.[0]);

            const arithmeticParamValue = parameterRef?.current?.filter(item => item?.parameterKey === condition?.arithmeticParamId && (item?.acOrDcParam ?? '')?.toLowerCase() === (condition?.arithmeticParamConnectorType ?? '')?.toLowerCase());
            if(arithmeticParamValue?.[0]) setSelectedArtihmeticParameter(arithmeticParamValue?.[0]);
        }
    },[advanceRuleEngineTriggerParameterReferenceData])


    const isEnumType = (fieldType: string | null) => {
        if (!fieldType) return false;
        return fieldType === 'DropDownSingle' || fieldType === 'DropDownMultiple' || fieldType === 'Toggle';
    }

    const getFieldType = (dataType: string | null) => {
        if(dataType === 'Date')return 'date';
        if(dataType === 'String') return 'text';
        return 'number';
    }

    const isBlockedCharacters = (val) => ['e','E','+','-','.']?.includes(val);

    const onViewDerivedConditionClick = (conditionId) => {
        if(!conditionId)return;
        dispatch(fetchDerivedCondition({id:conditionId})).then(data=>{
            derivedConditionImageUrlRef.current = data?.imageURL;
            setShowImage(true);
        })
    }

    const relationalOperators = useMemo(() => advanceRuleEngineRelationalOperatorReferenceData?.filter(item=>item?.id!=='is' && item?.id!=='isNot') ?? [],[advanceRuleEngineRelationalOperatorReferenceData]);
    const relationalOperatorsForEnum = useMemo(() => advanceRuleEngineRelationalOperatorReferenceData?.filter(item=>item?.id==='is' || item?.id==='isNot') ?? [],[advanceRuleEngineRelationalOperatorReferenceData]);
    const arithmeticOperators = useMemo(() => advanceRuleEngineArithmeticOperatorReferenceData ?? [],[advanceRuleEngineArithmeticOperatorReferenceData]);
    const connectives = useMemo(() => advanceRuleEngineConnectivesReferenceData ?? [],[advanceRuleEngineConnectivesReferenceData]);

    const checkValidationAndShowError = (key: string, value: string, param: IAdvanceRuleEngineTriggerParameterReferenceData): string | null => {
        const parsedValues = param?.possibleValue ? JSON.parse(param?.possibleValue) : null;
        if (param?.dataType === 'Integer') {
            if (!checkValidInteger(value)) return 'Enter a valid Integer value';
            if (key === 'parameter2Value' && parseInt(value) <= parseInt(condition?.parameter1Value as string)) {
                return 'The second value must be greater than the first value';
            }
            if(parsedValues && !(parseInt(value) >= parsedValues['min'] && parseInt(value) <= parsedValues['max'])){
                return `Please enter a value between ${parsedValues['min']} and ${parsedValues['max']}.`;
            }
        }
        if (param?.dataType === 'Double') {
            if (!checkValidDecimal(value)) return 'Enter a valid Double value';
            if (key === 'parameter2Value' && parseFloat(value) <= parseFloat(condition?.parameter1Value as string)) {
                return 'The second value must be greater than the first value';
            }
            if(parsedValues && !(parseFloat(value) >= parsedValues['min'] && parseFloat(value) <= parsedValues['max'])){
                return `Please enter a value between ${parsedValues['min']} and ${parsedValues['max']}.`;
            }
        }
        return null;
    }

    // const parseOptionValues = (values: string | null,number_key: string) => {
    //     if (!values) return [];
    //     // These are the keys (eg:last stop reason) for which code is added in the value which need to be removed from id and value.
    //     const special_keys = new Set(['1.5.1.4.8.11','1.5.1.4.3','1.5.1.3.8','1.5.1.3.13.18']);
    //     const parsedJson = JSON.parse(values);
    //     const options: IGeneralReferenceData[] = [];
    //     for (const key in parsedJson) {
    //         const label = parsedJson[key];
    //         const value = special_keys.has(number_key) ? label?.replace(/\(\d+\)$/, '') : label;
    //         options.push({ id: value, label: label, name: label, value });
    //     }
    //     return options
    // }

    const toggleArithmeticCondition = (val: boolean) => {
        const data = cloneDeep(condition);
        if (!val) {
            data.arithmeticParamId = null;
            data.arithmeticParamLabel = null;
            data.arithmeticParamLevel = null;
            data.arithmeticParamType = null;
            data.arithmeticParamValue = null;
            data.arithmeticOperator = null;
            data.arithmeticParamConnectorType = null;
            data.errorMessageArithmeticParam = null;

            setSelectedArtihmeticParameter(null);
        }
        else {
            if (data.operator === 'between' || data.operator === 'notBetween') {
                data.operator = null;
            }
            data.parameter1Value = null;
            data.parameter2Value = null;
        }
        handleConditionUpdate(data.condName, data);
        setEnableArtihmeticLogic(val);
    }

    return (
        <>
        <div className='advance__rule__engine__custom__condition__container' key={condition?.condName}>
            {
                position > 0  && <div className='advance__rule__engine__custom__connective__container'>
                    <SelectDropDown 
                        selectValue={connectives?.filter(item => item?.id === condition?.connective)?.[0]}
                        selectDropDownId={'advance__rule__engine__custom__connective-dropdown'} 
                        handleSelectOptionChange={ (value) => {
                            const data = cloneDeep(condition);
                            data.connective = value?.id;
                            handleConditionUpdate(data?.condName,data);
                        }} 
                        selectOptions={connectives}                
                    />
                </div>
            }
            <div className='advance__rule__engine__custom__condition__container-header'>
                <div className='advance__rule__engine__custom__condition-info'>
                    <div className='advance__rule__engine__custom__condition-label'>
                        {condition?.condName}
                    </div>
                    <div className='advance__rule__engine__custom__condition-label-description'>
                        <div className='advance__rule__engine__custom__condition-label-description-top'>Condition {condition?.condName}</div>
                        <div className='advance__rule__engine__custom__condition-label-description-bottom'>Define the statement</div>
                    </div>
                </div>
                <div className='advance__rule__engine__custom__condition-parameter-type-selection'>
                    <CustomDropDown
                        selectDropDownId='advance_rule_engine-parameter-type-selection-dropdown'
                        dropDownClassName='advance__rule__engine__parameter-type-selection-dropdown'
                        selectedValue={selectedParameterType}
                        handleSelectOptionChange={(value) => {
                            if (value?.id !== selectedParameterType?.id) {
                                setSelectedParameter(null);
                                const data = {
                                    condName: condition?.condName,
                                    condIdx: condition?.condIdx,
                                    paramId: null,
                                    paramLabel: null,
                                    paramType: null,
                                    paramLevel: null,
                                    operator: null,
                                    parameter1Value: null,
                                    parameter2Value: null,
                                    isParamTypeEnum: false,
                                    paramEnumValue: [],
                                    paramUnit: null,
                                    isParamTypeDate: false,
                                    isDerived: value?.id === 'DERIVED',

                                    connectorType: null,
                                    connectorScope: null,

                                    arithmeticParamId: null,
                                    arithmeticParamLabel: null,
                                    arithmeticParamType: null,
                                    arithmeticParamLevel: null,
                                    arithmeticOperator: null,
                                    arithmeticParamValue: null,
                                    arithmeticParamUnit: null,
                                    arithmeticParamConnectorType: null,

                                    connective: condition?.connective,

                                    errorMessage: null,
                                    errorMessageSecondary: null,
                                    errorMessageArithmeticParam: null
                                }
                                handleConditionUpdate(data?.condName, data);
                            }
                            setSelectedParameterType(value)
                            setSelectedParameter(null);
                            setArithmeticParamType(parameterTypeList?.[0]);
                            setEnableArtihmeticLogic(false);
                            setSelectedArtihmeticParameter(null);
                        }}
                        selectOptions={parameterTypeList}
                        renderToBody={true}
                    />
                </div>
            </div>
            <div className='advance__rule__engine__custom__condition__container-body'>
                {
                    !condition?.isDerived && <div className='advance__rule__engine__custom__condition__container-body-header'>
                        <div className='advance__rule__engine__custom__condition__container-body-header-col1'>Paramter*</div>
                        <div className='advance__rule__engine__custom__condition__container-body-header-col2'>Operator*</div>
                        <div className='advance__rule__engine__custom__condition__container-body-header-col3'>Value*</div>
                    </div>
                }
                <div className='advance__rule__engine__custom__condition__body-container'>
                    <div className={condition?.isDerived ? 'advance__rule__engine__custom__condition-parameter-derived' : 'advance__rule__engine__custom__condition-parameter'}>
                        <div className={condition?.isDerived ? 'advance__rule__engine__derived-parameter-label' : 'derived_condition_hide-label' }>
                            Derived Condition
                        </div>
                        <SelectDropDown
                            selectDropDownId='advance_rule_engine-custom-parameter-selection-dropdown'
                            dropDownClassName='advance_rule_engine-custom-parameter-selection-dropdown'
                            selectValue={selectedParameter}
                            handleSelectOptionChange={(value) => {
                                const data = cloneDeep(condition);
                                data.paramId = value?.parameterKey;
                                data.paramLabel = value?.label;
                                data.paramType = value?.parameterType;
                                data.paramLevel = value?.parameterLevel;
                                data.isParamTypeEnum = isEnumType(value?.fieldType);
                                data.isParamTypeDate = getFieldType(value?.dataType) === 'date';
                                data.isDerived = value?.parameterType === 'DERIVED';
                                data.connectorType = value?.parameterLevel === 'CONNECTOR' ? value?.acOrDcParam : null;
                                data.connectorScope = value?.parameterLevel === 'CONNECTOR' ? 'any' : null;
                                data.paramUnit = value?.unit && value?.unit != 'NA' ? value.unit : null;
                                if (data.isParamTypeEnum) toggleArithmeticCondition(false);
                                if(value?.dataType !== selectedParameter?.dataType || value?.fieldType !== selectedParameter?.fieldType){
                                    data.operator = null;
                                    data.parameter1Value = null;
                                    data.parameter2Value = null;
                                }
                                data.errorMessage = null;
                                data.errorMessageSecondary = null;
                                handleConditionUpdate(data?.condName, data);
                                setSelectedParameter(value);

                            }}
                            selectOptions={parameterRef?.current?.filter(item => item?.parameterType === selectedParameterType?.id) ?? []}
                            renderToBody={true}
                        />
                        <div className={condition?.isDerived ? 'advance__rule__engine__derived-parameter-view-icon' : 'derived_condition_hide-label'}>
                            <Icon iconClassName='advance__rule__engine__view__derived__condition__icon' onIconClick={()=>onViewDerivedConditionClick(condition?.paramId)}/>
                        </div>
                    </div>
                    {
                        !condition?.isDerived && <div className='advance__rule__engine__custom__condition-operator'>
                            <SelectDropDown
                                selectDropDownId='advance_rule_engine-custom-operator-selection-dropdown'
                                selectValue={(selectedParameter && (isEnumType(selectedParameter.fieldType!) || selectedParameter?.dataType === 'String') ? relationalOperatorsForEnum?.filter(item => item?.id === condition?.operator)?.[0] : relationalOperators?.filter(item => item?.id === condition?.operator)?.[0]) ?? null}
                                handleSelectOptionChange={(value) => {
                                    const data = cloneDeep(condition);
                                    data.operator = value?.id;
                                    if(value?.id !== 'between' && value?.id !== 'notBetween'){
                                        data.parameter2Value = null;
                                        data.errorMessageSecondary = null;
                                    }
                                    if(condition?.isParamTypeDate && value?.id !== condition?.operator){
                                        data.parameter1Value = null;
                                    }
                                    handleConditionUpdate(data?.condName, data);
                                }}
                                selectOptions={selectedParameter && (isEnumType(selectedParameter.fieldType!) || selectedParameter?.dataType === 'String') ? relationalOperatorsForEnum : enableArithmeticLogic ? relationalOperators?.filter(item => item?.id != 'between' && item?.id != 'notBetween') : relationalOperators}
                                renderToBody={true}
                                isDisabled={!selectedParameter}
                            />
                        </div>
                    }
                    {
                        !condition?.isDerived && !enableArithmeticLogic && <div className='advance__rule__engine__custom__condition-value'>
                            {
                                selectedParameter && isEnumType(selectedParameter?.fieldType) ?
                                    <SelectDropDown
                                        selectDropDownId={'advance__rule__engine__custom__condition-value-dropdown'}
                                        selectValue={parseOptionValues(selectedParameter?.possibleValue,selectedParameter?.numberKeyFormat)?.filter(item=> condition?.paramEnumValue?.includes(item?.value))}
                                        handleSelectOptionChange={
                                            (values) => {
                                                const data = cloneDeep(condition);
                                                data.paramEnumValue = values?.map(item=>item?.value);
                                                handleConditionUpdate(data?.condName, data);
                                            }
                                        }
                                        selectOptions={selectedParameter?.possibleValue ? parseOptionValues(selectedParameter?.possibleValue,selectedParameter?.numberKeyFormat) : []}
                                        renderToBody={true}
                                        isMultiSelect={true}
                                    />
                                    :
                                    condition?.operator && (condition?.operator === 'between' || condition?.operator === 'notBetween') ?
                                        <div className='advance__rule__engine__custom__condition-value-container'>
                                            <CustomInput
                                                inputValue={condition?.parameter1Value ? condition?.parameter1Value : ''}
                                                inputFieldId={'advance__rule__engine__custom__condition-value-1'}
                                                isRequired={true}
                                                inputType={getFieldType(selectedParameter?.dataType ?? null)}
                                                isDisabled={!condition?.operator}
                                                handleInputChange={(event) => {
                                                    const error = checkValidationAndShowError('parameter1Value', event?.target?.value, selectedParameter!);
                                                    const data = cloneDeep(condition);
                                                    data.errorMessage = error;
                                                    data.parameter1Value = event?.target?.value;
                                                    if (error) data.parameter2Value = null;
                                                    handleConditionUpdate(data?.condName, data);
                                                }}
                                                errorMessage={condition?.errorMessage}
                                            />
                                            <CustomInput
                                                inputValue={condition?.parameter2Value ? condition?.parameter2Value : ''}
                                                inputFieldId={'advance__rule__engine__custom__condition-value-2'}
                                                isRequired={true}
                                                inputType={getFieldType(selectedParameter?.dataType ?? null)}
                                                isDisabled={!condition?.parameter1Value}
                                                handleInputChange={(event) => {
                                                    const error = checkValidationAndShowError('parameter2Value', event?.target?.value, selectedParameter!);
                                                    const data = cloneDeep(condition);
                                                    data.errorMessageSecondary = error;
                                                    data.parameter2Value = event?.target?.value;
                                                    handleConditionUpdate(data?.condName, data);
                                                }}
                                                errorMessage={condition?.errorMessageSecondary}
                                            />
                                            {
                                                selectedParameter?.unit && selectedParameter?.unit != 'NA' && <div className='advance__rule__engine__custom__condition-value-unit-container'>
                                                    {selectedParameter?.unit}
                                                </div>
                                            }
                                        </div>
                                        :
                                        condition?.isParamTypeDate && condition?.operator  && (condition?.operator === 'greaterThan' || condition?.operator === 'lessThan' || condition?.operator === 'greaterThanEqualTo' || condition?.operator === 'lessThanEqualTo') ? 
                                         <div className='advance__rule__engine__custom__condition-date-value-container'>
                                            <div className='advance__rule__engine__custom__condition-value-label'>
                                                <span>Last</span>
                                            </div>
                                            <CustomInput
                                                inputValue={condition?.parameter1Value ? condition?.parameter1Value : ''}
                                                inputFieldId={'advance__rule__engine__custom__condition-date-value-1'}
                                                containerClassName={'advance__rule__engine__trigger__condition__date__value'}
                                                isRequired={true}
                                                inputType={'number'}
                                                isDisabled={!condition?.operator}
                                                handleKeyPress={(event)=>{
                                                    if(isBlockedCharacters(event?.key)){
                                                        event.preventDefault();
                                                    }
                                                }}
                                                handleInputChange={(event) => {
                                                    if(!isInteger(Number(event?.target?.value)))return;
                                                    const data = cloneDeep(condition);
                                                    data.parameter1Value = event?.target?.value;
                                                    handleConditionUpdate(data?.condName, data);
                                                }}
                                                errorMessage={condition?.errorMessage}
                                            />
                                            <div className='advance__rule__engine__custom__condition-value-label'>
                                                <span>days</span>  
                                                <IconWithTooltip
                                                    iconClassName="rms_info_icon-black"
                                                    containerClassName="user__form_footer-auto-assign-info"
                                                    toolTipText={
                                                        <>
                                                            <ul style={{ listStyleType: 'none', margin: 0, paddingLeft: 0 }}>
                                                                <li style={{ marginBottom: '5px' }}>Greater than last x days = Newer in the last x days</li>
                                                                <li style={{ marginBottom: '5px' }}>Less than last x days = Older than x days</li>
                                                            </ul>
                                                        </>
                                                    }
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div className='advance__rule__engine__custom__condition-value-container'>
                                            <CustomInput
                                                inputValue={condition?.parameter1Value ? condition?.parameter1Value : ''}
                                                inputFieldId={'advance__rule__engine__custom__condition-value-1'}
                                                isRequired={true}
                                                inputType={getFieldType(selectedParameter?.dataType ?? null)}
                                                isDisabled={!condition?.operator}
                                                handleInputChange={(event) => {
                                                    const error = checkValidationAndShowError('parameter1Value', event?.target?.value, selectedParameter!);
                                                    const data = cloneDeep(condition);
                                                    data.errorMessage = error;
                                                    data.parameter1Value = event?.target?.value;
                                                    handleConditionUpdate(data?.condName, data);
                                                }}
                                                errorMessage={condition?.errorMessage}
                                            />
                                            {
                                                selectedParameter?.unit && selectedParameter?.unit != 'NA' && <div className='advance__rule__engine__custom__condition-value-unit-container'>
                                                    {selectedParameter?.unit}
                                                </div>
                                            }
                                        </div>
                            }
                        </div>
                    }
                </div>
                <div className='advance__rule__engine__checkboxes__container'>
                    {
                        !condition?.isDerived && !condition?.isParamTypeEnum && !condition?.isParamTypeDate && <div className='advance__rule__engine__arithmetic__condition-toggle'>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-btn' onClick={
                                () => {
                                    if(!selectedParameter || isEnumType(selectedParameter?.fieldType) || getFieldType(selectedParameter?.dataType) === 'date' || condition?.isDerived)return;
                                    toggleArithmeticCondition(!enableArithmeticLogic)
                                }}>
                                <CheckBox
                                    checked={enableArithmeticLogic}
                                    isDisabled={!selectedParameter || isEnumType(selectedParameter?.fieldType) ||  getFieldType(selectedParameter?.dataType) === 'date' || condition?.isDerived}
                                />
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-label'>
                                Arithmetic Logic
                            </div>
                        </div>
                    }
                    {
                        condition?.paramLevel==='CONNECTOR' && <div className='advance__rule__engine__arithmetic__condition-toggle'>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-btn' onClick={
                                () => {
                                    if(!selectedParameter || condition?.paramLevel!=='CONNECTOR')return;
                                    const data = cloneDeep(condition);
                                    data.connectorScope = condition.connectorScope === 'all' ? 'any' : 'all';
                                    handleConditionUpdate(data?.condName, data);
                                }}>
                                <CheckBox
                                    checked={condition?.connectorScope === 'all'}
                                    isDisabled={!selectedParameter || condition?.paramLevel!=='CONNECTOR'}
                                />
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-toggle-label'>
                                Check for all connectors
                            </div>
                        </div>
                    }
                </div>
                <div className='advance__rule__engine__arithmetic__condition__body-container'>
                    {
                        enableArithmeticLogic && <div className='advance__rule__engine__arithmetic__condition__body'>
                            <div className='advance__rule__engine__arithmetic__condition-parameter-container'>
                                <div className='advance__rule__engine__arithmetic__condition-parameter-type'>
                                    <CustomDropDown
                                        selectDropDownId={'advance-rule-engine-arithmetic-parameter-type-dropdown'}
                                        dropDownClassName={'advance__rule__engine__arithmetic__parameter-type-dropdown-compact'}
                                        selectedValue={arithmeticParamType}
                                        selectOptions={parameterTypeList?.filter(item => item?.id === 'STATUS' || item?.id === 'SETTING')}
                                        renderToBody={true}
                                        handleSelectOptionChange={
                                            (value) => {
                                                if (value?.id != arithmeticParamType?.id) {
                                                    const data = cloneDeep(condition);
                                                    data.arithmeticParamId = null;
                                                    data.arithmeticParamLabel = null;
                                                    data.arithmeticParamLevel = null;
                                                    data.arithmeticParamType = null;
                                                    data.arithmeticParamValue = null;
                                                    data.arithmeticOperator = null;
                                                    data.errorMessageArithmeticParam = null;
                                                    data.arithmeticParamUnit = null;
                                                    data.arithmeticParamConnectorType = null;

                                                    setSelectedArtihmeticParameter(null);
                                                    handleConditionUpdate(data.condName, data);
                                                }
                                                setArithmeticParamType(value);
                                            }
                                        }
                                    />
                                </div>
                                <div className='advance__rule__engine__arithmetic__condition-parameter'>
                                    <SelectDropDown
                                        selectDropDownId={'advance__rule__engine__arithmetic__condition-parameter'}
                                        selectValue={selectedArithmeticParameter}
                                        handleSelectOptionChange={
                                            (value) => {
                                                const data = cloneDeep(condition);
                                                data.arithmeticParamId = value?.parameterKey;
                                                data.arithmeticParamLabel = value?.label;
                                                data.arithmeticParamLevel = value?.parameterLevel;
                                                data.arithmeticParamType = value?.parameterType;
                                                data.arithmeticParamUnit = value?.unit && value?.unit != 'NA' ? value.unit : null;
                                                data.arithmeticParamConnectorType = value?.parameterLevel === 'CONNECTOR' ? value?.acOrDcParam : null
                                                data.errorMessageArithmeticParam = null;
                                                setSelectedArtihmeticParameter(value);
                                                handleConditionUpdate(data.condName, data);
                                            }
                                        }
                                        renderToBody={true}
                                        selectOptions={parameterRef?.current?.filter(item => item?.parameterType === arithmeticParamType?.id && !isEnumType(item?.fieldType)) ?? []}
                                    />
                                </div>
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-operator'>
                                <SelectDropDown
                                    selectDropDownId='advance_rule_engine-arithmetic-operator-selection-dropdown'
                                    selectValue={arithmeticOperators?.filter(item => item.id === condition?.arithmeticOperator)?.[0] ?? null}
                                    handleSelectOptionChange={(value) => {
                                        const data = cloneDeep(condition);
                                        data.arithmeticOperator = value?.id;
                                        handleConditionUpdate(data?.condName, data);
                                    }}
                                    selectOptions={arithmeticOperators}
                                    renderToBody={true}
                                    isDisabled={!selectedArithmeticParameter}
                                />
                            </div>
                            <div className='advance__rule__engine__arithmetic__condition-value'>
                                <CustomInput
                                    inputValue={condition?.arithmeticParamValue ? condition?.arithmeticParamValue : ''}
                                    inputFieldId={'advance__rule__engine__arithmetic__condition-value'}
                                    isRequired={true}
                                    isDisabled={!condition?.arithmeticOperator}
                                    handleInputChange={(event) => {
                                        const error = checkValidationAndShowError('arithmeticParamValue', event?.target?.value, selectedArithmeticParameter!);
                                        const data = cloneDeep(condition);
                                        data.errorMessageArithmeticParam = error;
                                        data.arithmeticParamValue = event?.target?.value;
                                        handleConditionUpdate(data?.condName, data);
                                    }}
                                    errorMessage={condition?.errorMessageArithmeticParam}
                                />
                                {
                                    selectedArithmeticParameter && selectedArithmeticParameter?.unit != 'NA' && <div className='advance__rule__engine__trigger__condition-value-unit-container'>
                                        {selectedArithmeticParameter?.unit}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
        <CustomChartPopup 
            show={showImage}
        >
            <img
                src={derivedConditionImageUrlRef?.current}
                alt='derived-condition-image'
                style={{
                display: derivedConditionImageUrlRef?.current ? 'block' : 'none',
                width: '100%',
                maxWidth: '800px',
                height: 'auto',
                borderRadius: '8px',
                scale: 0.75,
                }}
            />
            <IconButton
                    size="small"
                    onClick={() => { }}
                    sx={{
                        position: 'absolute',
                        right: '8px',
                        top: '8px',
                    }}
                >
                <CloseIcon
                    onClick={() => setShowImage(false)}
                    fontSize="small"
                    sx={{ color: '#000' }} 
                />
            </IconButton>
        </CustomChartPopup>
        </>
    )
}

export default CustomConditionComponent